export default "__VITE_ASSET__pr3vdcvh__"